import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Nutzungsbedingungen = () => {
  return (
    <LegalLayout title="Nutzungsbedingungen">
      <div className="space-y-6">
        <p>
          Willkommen auf der Webseite der Browser Lock Extension. Durch die Nutzung dieser Webseite erklären Sie sich mit den folgenden Nutzungsbedingungen einverstanden.
        </p>

        <h2 className="text-2xl font-bold text-textMain mt-8 mb-4">1. Zweck der Webseite</h2>
        <p>
          Diese Webseite dient ausschließlich der Information über die Browser Lock Extension und bietet Links zu den Installationsseiten in den jeweiligen Browser-Stores.
        </p>

        <h2 className="text-2xl font-bold text-textMain mt-8 mb-4">2. Inhalte und Haftung</h2>
        <p>
          Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten verantwortlich.
        </p>

        <h2 className="text-2xl font-bold text-textMain mt-8 mb-4">3. Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung und Verbreitung bedürfen der schriftlichen Zustimmung des jeweiligen Autors.
        </p>

        <p className="mt-8 text-sm">Stand: Februar 2024</p>
      </div>
    </LegalLayout>
  );
};

export default Nutzungsbedingungen;